/*89209 copiati ed incollati da cp.common per ovviare all'import in bulk di tutto il cp.comoon dalle public.api.ts
 * che porta alla rottura degli specs negli afterall*/
import { primitiveType } from '@se/cp.common';

export type JsonPrimitive = null | boolean | number | string | JsonPrimitive[];
export type JsonObject = { [prop: string]: Json };
export type Json = JsonPrimitive | JsonObject | Json[];

export interface IDisabledConfig {
    placeholders: string[];
    formula: string;
}

export enum EIntegrationType {
    'BUTTON' = 'BUTTON',
    'ON_CALL' = 'ON_CALL',
}

export type PairingTokenBundle = {
    access_token: string;
    expires_in: number;
    refresh_token: string;
    id_token: string;
};

export interface IRefreshTokenData {
    actionId: string;
    refreshUri: string;
    cacheKey: string; //dove salvare il risultato della chiamata di refresh token da configurare in modo che sia richiamabile nelle calls di  type button
    cacheInitialValue: PairingTokenBundle; //valore da iniettare alla chiamata se necessario
    isReset: boolean; //se true chiede di resettare il setinterval della chiamata di refresh token
}

/*type guard*/
export const isRefreshTokenData = (data: any): data is IRefreshTokenData =>
    data && typeof data === 'object' && data.actionId && data.refreshUri && data.cacheKey;

/* potrebbe essere obsoleto. se si vuole evitare un nuovo sviluppo per ogni action
 * le action non configurate servono semplicemente per inserire nuovi dati nella cache da altri servizi nell'applicazione*/
export type EAvailableActions = 'REFRESH_TOKEN';

export type AvailableActionDataType = IRefreshTokenData | any;

export interface IOnCallActionData {
    action: EAvailableActions;
    data: AvailableActionDataType;
}

export enum EEnableButtonOnSelection {
    ALWAYS = 'ALWAYS',
    SINGLE = 'SINGLE',
    SINGLE_AND_MULTI = 'SINGLE_AND_MULTI',
    MULTI = 'MULTI',
}

export interface IExternalIntegration {
    id: string;
    type: EIntegrationType;
    label: string;
    description: string;
    where: EWhere;
    calls: IExternalIntegrationCall[];
    debug: boolean;
    disabled?: IDisabledConfig;
    alwaysEnabled?: boolean;
    position?: number; //se manca di default va in fondo se -1/negativo/Infinity va comunque in fondo
    /*parametri per ON_CALL type*/
    action: EAvailableActions; //action da chiamare internamente es REFRESH_TOKEN
    /*ciascun action name deve corrispondere ad un metodo private del servizio
che viene chiamato esternamente tramite .next su behaviourSubject
essendo una gestione oncall interna ai moduli ts estensa non ci sono problematiche di sicurezza
nel lasciare tale parte del json di configurazione nella cartella /assets
le uri se presenti vengono iniettate in esecuzione dal servizio chiamante e nessuna routine viene chiamata direttamente
ma solo scatenando un'osservabile con i parametri corretti (vedi IRefreshTokenData come esempio per gestire il refresh token sso )
*/
    test?: boolean; //se true viene usato fetch al posto di angular http cosi da evitare problemi di cors testando in locale
    constants?: Record<string, Json>;
    enableButtonOnSelection?: EEnableButtonOnSelection;
    cacheKey?: string; // nel caso di on_call type la key della cache dove salvare i dati
    icon?: string; // definisce l'icona per button html5
    ctxIcon?: string; // definisce l'icona per button html5
    breaked?: boolean; // per button html5
}

export enum EOperator {
    'GREATER' = 'GREATER',
    'EQUAL' = 'EQUAL',
    'GREATER_EQUAL' = 'GREATER_EQUAL',
    'LESS' = 'LESS',
    'LESS_EQUAL' = 'LESS_EQUAL',
    'NOT_EQUAL' = 'NOT_EQUAL',
}

export interface IErrorManagement {
    path: string; //path relativo all'oggetto ricevuto dalla chiamata rest non a tutto il datastore
    operator: EOperator;
    valueTrigger: string;
    action: EOnError;
    message: string;
    notify?: boolean; //notify and translate message
}

export interface IFindConfig {
    keyPathToSearch: string; // si tratta della prop al'interno di ogni entry di arrayToSearchIn da testare con valueToMatch
    valueToMatch: string | string[]; // value to match puo essere exam.id ovvero l'id dell esame selezionato oppure un array con gli id degli esami selezionati
    arrayToSearchIn: any[];
}

export type InputEntryConfig = {
    name: string; // l'output del form andra nel datastore al path specificato nel target ed avra come prop i nomi degli inputs
    label: string;
    sourceDataPath: string; //path relativo al datastore corrente da usare per select e multi-select
    optionIdPath: string; //path interno ad ogni oggetto di sourceDataPath relativo all'id da usare come value nelle option
    optionLabelPath: string; // path interno ad ogni oggetto di sourceDataPath relativo al label da mostrare nelle option
    sourceData: any[]; // dati inseriti a mano nel json
    inputType: 'select' | 'multi-select' | 'number' | 'text' | 'boolean' | 'date' | 'password';
    nonNullable: boolean;
    required: boolean;
    initialValue?: any;
};

export enum EFormMethod {
    GET = 'GET',
    POST = 'POST',
}

export enum EFormTarget {
    _blank = '_blank',
    _self = '_self',
    _parent = '_parent',
    _top = '_top',
}

export interface IFormCallConfig {
    skipOnPreFill: boolean; //se tutti dati sono gia compilati da default value oppure select con singola opzione allora passare alla call successiva
    isSubmitForm: boolean; //se il form viene inviato al backend
    target: string | EFormTarget; //string nel caso si usi framename
    method: EFormMethod;
    action: string;
    submitLabel: string;
    cancelLabel?: string;
    inputList: InputEntryConfig[];
}

export enum EResponseType {
    'json' = 'json',
    'text' = 'text',
    'arraybuffer' = 'arraybuffer',
    'blob' = 'blob',
}

/**
 * record di path nella call corrente es 'body.patientID':{ fn: 'toUpper', params: ['body.patientID'] }
 * il path e` il percorso in cui si vuole scrivere il risultato dell'applicazione della funzione
 * la funziona viene presa da una mappa di routine custom create appositamente per questo servizio
 * i params delle funzioni posso contenere anche dei placeholders ma del tipo {F_i} in modo da evitare i conflitti con il parsing iniziale sui {B_i}
 * il primo parametro passato di default e` l'oggetto trovato nel path
 */
export type PostParseProcessing = Record<string, { fnName: string; params: primitiveType[] }>;

export interface IExternalIntegrationCall {
    description: string;
    type: EExternalIntegrationCallType; // tipo di chiamata
    url?: string;
    httpMethod?: EHttpMethod;
    xmlns?: Record<string, string>; // oggetto di name spaces  per chiamate rest SOAP
    httpErrorPath?: string; // path su cui cercare il messaggio di errore in caso di chiamata http
    responseType?: EResponseType;
    body?: Json;
    placeholders: string[];
    cacheKey?: string; //chiave da utilizzare per la cache, per ogni chiamata controllare se c'e un dato presente in cache e scriverlo nel target. altrimenti procedere con il flusso normale
    target?: string; // dove inserire il risultato
    errorHandling?: IErrorManagement;
    headers?: Record<string, string>; //campi opzionali da aggiungere all'header http
    authenticationData?: Record<string, string>; // campi che vengono codificati in base64 e passati nel header Authentication
    findConfig?: IFindConfig;
    test?: boolean;
    formConfig?: IFormCallConfig;
    notifySuccessPath?: string; // path relativo al datastore corrente da utilizzare per notificare il successo della chiamata. se nullish non usato
    notifySuccessString?: string; // se il path non presente ma vogliamo notificare successo con testo cablato
    notificationMessage?: string;
    notificationData?: Json;
    postParseProcessing?: PostParseProcessing;
}

export enum EExternalIntegrationCallType {
    NOTIFICATION = 'NOTIFICATION',
    REST_EXTERNAL = 'REST_EXTERNAL',
    REST_EXTERNAL_SOAP = 'REST_EXTERNAL_SOAP',
    REST_ESTENSA = 'REST_ESTENSA',
    MODAL_WINDOW_URL = 'MODAL_WINDOW_URL',
    FIND_IN_DATA = 'FIND_IN_DATA',
    TAB_WINDOW_URL = 'TAB_WINDOW_URL',
    CACHE_OP = 'CACHE_OP',
    FORM = 'FORM',
    ERROR = 'ERROR',
}

export enum EHttpMethod {
    GET = 'GET',
    POST = 'POST',
    DELETE = 'DELETE',
    PUT = 'PUT',
    PATCH = 'PATCH',
}

export enum EOnError {
    CONTINUE = 'CONTINUE',
    BREAK = 'BREAK',
}

/*riprendere i nomi delle pagine gia usati*/
export enum EWhere {
    CUSTOM_PAGE_CARDIOLOGY_VISIT = 'CUSTOM_PAGE_CARDIOLOGY_VISIT',
    CUSTOM_PAGE_TELECONSULTATION = 'CUSTOM_PAGE_TELECONSULTATION',
    CUSTOM_PAGE_TELEMONITORING_VISIT = 'CUSTOM_PAGE_TELEMONITORING_VISIT',
    CUSTOM_PAGE_ULTRASOUND = 'CUSTOM_PAGE_ULTRASOUND',
    CUSTOM_PAGE_SPECIALTY = 'CUSTOM_PAGE_SPECIALTY',
    ECG_PAGE = 'ECG_PAGE',
    LIST_PAGE_VISIT = 'LIST_PAGE_VISIT',
    LIST_PAGE_ECG = 'LIST_PAGE_ECG',
    LIST_PAGE_COMPLETE_CD = 'LIST_PAGE_COMPLETE_CD',
    LIST_PAGE_COLLABORATION = 'LIST_PAGE_COLLABORATION',
    LIST_PAGE_ON_PRINTING_CD = 'LIST_PAGE_ON_PRINTING_CD',
    LIST_PAGE_TELEMONITORING = 'LIST_PAGE_TELEMONITORING',
    LIST_PAGE_NRE = 'LIST_PAGE_NRE',
    LIST_PAGE_SPECIALTY = 'LIST_PAGE_SPECIALTY',
    EXECUTION = 'EXECUTION',
    HTML5_PATIENT = 'HTML5_PATIENT',
    HTML5_PATIENT_FOLDER = 'HTML5_PATIENT_FOLDER',
    HTML5_ADMISSION = 'HTML5_ADMISSION',
    HTML5_ADMISSION_BOOKING = 'HTML5_ADMISSION_BOOKING',
    HTML5_EXECUTION = 'HTML5_EXECUTION',
    HTML5_LIST_RADIO = 'HTML5_LIST_RADIO',
    HTML5_PAGE_RADIO = 'HTML5_PAGE_RADIO',
    HTML5_LIST_SCREENING_I = 'HTML5_LIST_SCREENING_I_LEVEL',
    HTML5_PAGE_SCREENING_II = 'HTML5_PAGE_SCREENING_II_LEVEL',
    HTML5_PAGE_SENOLOGY = 'HTML5_PAGE_SENOLOGY',
}

export type FullIntegrationStoreData = Record<string, Json>;

export interface INotificationMessage {
    name: string;
    data: any;
}
